import React, { useEffect, useState } from 'react';
import { monthList, splitDate } from './utils';
import Select from '../Select';

const Index = (props) => {
    const {
        value,
        filedName,
        isDisableButton,
        minMonth,
        maxMonth,
        minDate,
        maxDate,
        visible,
        onChange
    } = props;
    const parseDate = splitDate(value ? value : '');
    const { month, day } = parseDate;
    const [selectedMonth, setSelectedMonth] = useState(month);
    const [selectedDate, setSelectedDate] = useState(day);
    const months = monthList();

    useEffect(() => {
        if (selectedMonth || selectedDate) {
            if (!value) {
                setSelectedDate('');
                setSelectedMonth('');
            }
        }
        if(value){
            const parseDate1 = splitDate(value ? value : '');
            const { month, day } = parseDate1;
            setSelectedDate(day);
            setSelectedMonth(month);
        }
    }, [value])
    return (
        <div className='grid grid-flow-col grid-rows-1 grid-cols-2 gap-1'>
            <input
                type={visible ? 'text' : 'hidden'}
                name={filedName}
                placeholder="MMMM-DD"
                value={selectedMonth && selectedDate ? '1900-' + selectedMonth + '-' + selectedDate : ''}
                readOnly
            />
            <div className='pl-0 pr-4'>

                <Select
                    isMulti={false}
                    options={
                        minMonth && maxMonth ?
                            months?.filter((n) => parseInt(n?.value) >= parseInt(minMonth) && parseInt(n?.value) <= parseInt(maxMonth))
                            : minMonth ?
                                months?.filter((n) => parseInt(n?.value) >= parseInt(minMonth))
                                : maxMonth ?
                                    months?.filter((n) => parseInt(n?.value) <= parseInt(maxMonth))
                                    : months
                    }
                    value={months?.filter((n) => n?.value === selectedMonth)}
                    onChange={(value) => {
                        let selectDate = selectedDate;
                        if (value?.totalDays?.length < (parseInt(selectedDate) - 1)) {
                            selectDate = '01';
                            setSelectedDate('01');
                        }
                        setSelectedMonth(value.value)
                        let setValue = value?.value && selectDate ? '1900-' + value?.value + '-' + selectDate : '';
                        onChange(setValue)
                    }}
                    isDisabled={isDisableButton}
                />
            </div>
            <div className='pl-4 pr-0'>
                <Select
                    isMulti={false}
                    options={
                        months?.find((n) => n?.value === selectedMonth) ?
                            minDate && maxDate ?
                                (months?.find((n) => n?.value === selectedMonth)?.totalDays)?.filter((n) => parseInt(n?.value) >= parseInt(minDate) && parseInt(n?.value) <= parseInt(maxDate))
                                : minDate && parseInt(minMonth) === parseInt(selectedMonth)?
                                    (months?.find((n) => n?.value === selectedMonth)?.totalDays)?.filter((n) => parseInt(n?.value) >= parseInt(minDate))
                                    : maxDate ?
                                        (months?.find((n) => n?.value === selectedMonth)?.totalDays)?.filter((n) => parseInt(n?.value) <= parseInt(maxDate))
                                        : (months?.find((n) => n?.value === selectedMonth)?.totalDays)
                            : []
                    }
                    value={months?.find((n) => n?.value === selectedMonth) ? (months?.find((n) => n?.value === selectedMonth)?.totalDays)?.filter((n) => n?.value === selectedDate) : []}
                    onChange={(value) => {
                        setSelectedDate(value.value)
                        let setValue = selectedMonth && value?.value ? '1900-' + selectedMonth + '-' + value?.value : '';
                        onChange(setValue)
                    }}
                    isDisabled={isDisableButton}

                />
            </div>
        </div>
    )
}
export default Index;